import "./LegalFooter.css";

function LegalFooter() {
    return <span className="legalFooter">
        <a href={"https://www.navo.niedersachsen.de/navo2/portal/desktop/0/kontakt"}>Kontakt</a>
        <a href={"https://www.navo.niedersachsen.de/navo2/portal/desktop/0/privacyStatement?appiid=0"}>Datenschutz </a>
        <a href={"https://www.navo.niedersachsen.de/navo2/portal/desktop/0/impressum?appiid=0"}>Impressum </a>
    </span>
}

export default LegalFooter